/* L'Orchidea - preferiti salvati nel browser (localStorage).
   Pulsanti: [data-orc-wish="handle-prodotto"]. Contatori: [data-orc-wish-count].
   Evento "orc:wishlist" con l'elenco aggiornato. API per la pagina wishlist: window.OrcWishlist. */
(() => {
  const KEY = 'orc-wishlist';

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage non disponibile (navigazione privata): i preferiti restano solo in pagina */
    }
  };

  const sync = (root = document) => {
    const list = read();
    root.querySelectorAll('[data-orc-wish]').forEach((button) => {
      const saved = list.includes(button.dataset.orcWish);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
    document.querySelectorAll('[data-orc-wish-count]').forEach((count) => {
      count.textContent = list.length;
      count.hidden = list.length === 0;
    });
  };

  const beat = (element) => {
    element.classList.remove('is-beating');
    void element.offsetWidth;
    element.classList.add('is-beating');
    element.addEventListener('animationend', () => element.classList.remove('is-beating'), { once: true });
  };

  const remove = (handle) => {
    const list = read().filter((item) => item !== handle);
    write(list);
    sync();
    document.dispatchEvent(new CustomEvent('orc:wishlist', { detail: { list } }));
  };

  window.OrcWishlist = { read, remove };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-orc-wish]');
    if (!button) return;
    // il pulsante sta dentro il link della scheda: non aprire il prodotto
    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.orcWish;
    const list = read();
    const index = list.indexOf(handle);
    if (index === -1) list.unshift(handle);
    else list.splice(index, 1);
    write(list);
    sync();

    // battito solo quando il prodotto viene aggiunto: sul cuore premuto e su quello dell'header
    if (index === -1) {
      beat(button);
      document.querySelectorAll('[data-orc-header-wish]').forEach(beat);
    }
    document.dispatchEvent(new CustomEvent('orc:wishlist', { detail: { list } }));
  }, true);

  // Le griglie si ricaricano con filtri, ordinamento e paginazione
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      sync();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    sync();
    document.dispatchEvent(new CustomEvent('orc:wishlist', { detail: { list: read() } }));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync());
  else sync();
})();
